import { Injectable } from '@angular/core';
import { ElementSVC } from './element-svc';
import { HttpClient } from '@angular/common/http';
import { ServiceType } from '../common/interfaces/service-type';
import { concatMap, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ServiceTypeService extends ElementSVC {

  data: ServiceType[] = [];

  constructor(protected override http: HttpClient) {

    super(http);
    this.apiurl += '/service-types';

  }

  getWorkTypes(idservicetype){
      
    return this.http.get(this.apiurl + '/' + idservicetype + '/work-types');
  
  }

  getServiceTypes(){
    
    return this.data;

  }

  getPaginate(filter?: string){

    return this.http.get(this.apiurl + '-paginate' + (filter!=undefined ? '?' + filter : ''));

  }

  getServiceTypeById(id: number){
    return this.data.find((el) => el.id == id);
  }
  
  

  initialize(){

    return this.http.get(this.apiurl).pipe(concatMap((_ : ServiceType[]) => {

      this.data = _;
      return of(true);
      
    }));
  
  }

}
